import React from 'react';
import './Tjanstevillkor.css';

function Tjanstevillkor() {
  return (
    <div className="tos-page">
      <div className="tos-container">
        <h1>Tjänstevillkor — Digitalt Besökssystem</h1>
        <p className="tos-updated">Senast uppdaterad: 2026-02-21</p>

        <hr />

        <section>
          <h2>1. Inledning</h2>
          <p>
            Dessa tjänstevillkor ("Villkoren") gäller för användning av det webbaserade
            besöksregistreringssystemet ("Systemet") som tillhandahålls av Tech Management
            Solutions Sweden AB ("Leverantören"). Genom att använda Systemet godkänner kunden ("Kunden") dessa villkor.
          </p>
          <p>
            Villkoren kompletterar det avtal som tecknats mellan Leverantören och Kunden ("Avtalet").
            Vid konflikt mellan Villkoren och Avtalet har Avtalet företräde.
          </p>
        </section>

        <hr />

        <section>
          <h2>2. Användning av systemet</h2>

          <h3>2.1 Tillåten användning</h3>
          <p>Kunden får använda Systemet för att:</p>
          <ul>
            <li>Registrera besökare vid kundens verksamhetsställen</li>
            <li>Hantera in- och utcheckning av besökare</li>
            <li>Ta del av besökshistorik</li>
          </ul>

          <h3>2.2 Kundens ansvar</h3>
          <p>Kunden ansvarar för att:</p>
          <ul>
            <li>Användningen sker i enlighet med gällande lagstiftning</li>
            <li>Behöriga personer inom kundens organisation informeras om korrekt användning</li>
            <li>Inte försöka kringgå säkerhetsåtgärder, manipulera eller reverse-engineera Systemet</li>
            <li>Inte använda Systemet för att lagra information utöver vad som är avsett</li>
            <li>Omedelbart meddela Leverantören vid misstanke om obehörig åtkomst</li>
          </ul>

          <h3>2.3 Kontoinformation</h3>
          <p>
            Kunden ansvarar för att hålla sina kontaktuppgifter aktuella och för att säkerställa
            att åtkomst till Systemet hanteras på ett säkert sätt inom den egna organisationen.
          </p>
        </section>

        <hr />

        <section>
          <h2>3. Tillgänglighet och support</h2>

          <h3>3.1 Tillgänglighet</h3>
          <ul>
            <li>Leverantören eftersträvar hög tillgänglighet men garanterar ingen specifik drifttid</li>
            <li>Planerat underhåll aviseras minst 24 timmar i förväg via e-post</li>
            <li>Leverantören ansvarar inte för avbrott orsakade av tredjepartsleverantörer eller omständigheter utanför Leverantörens kontroll</li>
          </ul>

          <h3>3.2 Support</h3>
          <ul>
            <li>Teknisk support tillhandahålls via e-post</li>
            <li>Svar lämnas inom 2 arbetsdagar</li>
            <li>Supporten omfattar felsökning och vägledning i användning av Systemet</li>
            <li>Support inkluderar inte utbildning, ny funktionalitet eller anpassningar (se tilläggsarbete i Avtalet)</li>
          </ul>
        </section>

        <hr />

        <section>
          <h2>4. Personuppgifter och dataskydd (GDPR)</h2>

          <h3>4.1 Roller och ansvar</h3>
          <p>
            <strong>Kunden är personuppgiftsansvarig (Data Controller)</strong> för de personuppgifter
            som registreras i Systemet. Kunden bestämmer ändamål och medel för behandlingen.
          </p>
          <p>
            <strong>Leverantören är personuppgiftsbiträde (Data Processor)</strong> och behandlar
            personuppgifter på uppdrag av och enligt instruktioner från Kunden.
          </p>

          <h3>4.2 Kundens skyldigheter som personuppgiftsansvarig</h3>
          <p>Kunden ansvarar för att:</p>
          <ul>
            <li>Ha rättslig grund för insamling av besökares personuppgifter (t.ex. berättigat intresse eller samtycke)</li>
            <li>Informera besökare om att deras personuppgifter samlas in, i vilket syfte, och hur länge de lagras (t.ex. genom skyltning vid receptionen)</li>
            <li>Hantera registrerades rättigheter (åtkomst, rättelse, radering, dataportabilitet)</li>
            <li>Genomföra en konsekvensbedömning (DPIA) om så krävs enligt gällande dataskyddslagstiftning</li>
            <li>Säkerställa att insamlade uppgifter är adekvata, relevanta och inte överflödiga i förhållande till ändamålet</li>
          </ul>

          <h3>4.3 Leverantörens skyldigheter som personuppgiftsbiträde</h3>
          <p>Leverantören förbinder sig att:</p>
          <ul>
            <li>Endast behandla personuppgifter i enlighet med Kundens dokumenterade instruktioner och för det ändamål som beskrivs i detta avtal</li>
            <li>Inte behandla personuppgifter för egna ändamål</li>
            <li>Säkerställa att personal som behandlar personuppgifter omfattas av sekretessåtaganden</li>
            <li>Bistå Kunden med att uppfylla sina skyldigheter enligt GDPR, inklusive att svara på förfrågningar från registrerade</li>
            <li>Radera eller återlämna alla personuppgifter efter avtalets upphörande, i enlighet med Kundens instruktioner (se Avtalet punkt 5.3)</li>
            <li>Inte anlita underbiträden utan att informera Kunden (se punkt 4.8)</li>
          </ul>

          <h3>4.4 Kategorier av personuppgifter</h3>
          <p>Följande personuppgifter behandlas i Systemet:</p>
          <ul>
            <li>Namn</li>
            <li>Företagstillhörighet</li>
            <li>Telefonnummer</li>
            <li>Besöksorsak</li>
            <li>Tidpunkt för in- och utcheckning</li>
          </ul>
          <p>Inga känsliga personuppgifter (artikel 9 GDPR) behandlas i Systemet.</p>

          <h3>4.5 Automatisk dataradering</h3>
          <p>
            Besöksposter raderas automatiskt efter <strong>30 dagar</strong>. Radering sker dagligen
            och inkluderar återvinning av lagringsutrymme. Kunden kan inte begära förlängd
            lagringstid utan separat överenskommelse.
          </p>

          <h3>4.6 Säkerhetsåtgärder</h3>
          <p>Leverantören har vidtagit följande tekniska och organisatoriska åtgärder för att skydda personuppgifter:</p>

          <h4>Tekniska åtgärder:</h4>
          <ul>
            <li>Krypterad dataöverföring (TLS/SSL via Let's Encrypt)</li>
            <li>Krypterad autentisering med bcrypt-hashning och tidskonstant jämförelse</li>
            <li>JWT-baserad sessionshantering med 256-bitars krypteringsnyckel</li>
            <li>Säkra cookies (httpOnly, Secure, SameSite=Strict) som skydd mot XSS och CSRF</li>
            <li>Progressiv hastighetsbegränsning vid upprepade misslyckade inloggningsförsök (10 min, 30 min, 1 timme, permanent blockering)</li>
            <li>Hastighetsbegränsning på API-nivå (Nginx och applikationsnivå)</li>
            <li>Automatisk detektering och permanent blockering av skadliga IP-adresser (skannerdetektering)</li>
            <li>HTTP-säkerhetsrubriker (Content-Security-Policy, X-Frame-Options, X-Content-Type-Options, X-XSS-Protection)</li>
            <li>Indatavalidering och sanering (HTML-rensning, skriptfiltrering, null-byte-borttagning)</li>
            <li>Parameteriserade databasfrågor via ORM (skydd mot SQL-injektion)</li>
            <li>Automatisk säkerhetskopiering</li>
            <li>Brandvägg och nätverksskydd</li>
          </ul>

          <h4>Organisatoriska åtgärder:</h4>
          <ul>
            <li>Begränsad åtkomst till produktionsmiljön (enbart Leverantören)</li>
            <li>Sekretessåtaganden</li>
            <li>Incidenthanteringsrutiner</li>
            <li>Strukturerad loggning av säkerhetshändelser</li>
          </ul>

          <h3>4.7 Incidenthantering</h3>
          <ul>
            <li>Vid bekräftad personuppgiftsincident (dataintrång) underrättar Leverantören Kunden utan onödigt dröjsmål och senast inom <strong>72 timmar</strong> från det att incidenten upptäckts</li>
            <li>Underrättelsen ska innehålla: typ av incident, berörda uppgifter, vidtagna åtgärder och kontaktuppgifter</li>
            <li>Kunden ansvarar för att vid behov anmäla incidenten till Integritetsskyddsmyndigheten (IMY) samt underrätta berörda registrerade</li>
          </ul>

          <h3>4.8 Underbiträden</h3>
          <p>Leverantören anlitar följande underbiträden för att tillhandahålla Systemet:</p>
          <table>
            <thead>
              <tr>
                <th>Underbiträde</th>
                <th>Ändamål</th>
                <th>Plats</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Amazon Web Services (AWS)</td>
                <td>Serverhosting och infrastruktur</td>
                <td>EU (Stockholm)</td>
              </tr>
            </tbody>
          </table>
          <p>
            Leverantören informerar Kunden skriftligen minst 30 dagar i förväg vid byte av eller
            tillägg av underbiträde. Kunden har rätt att invända mot nytt underbiträde. Om parterna
            inte kan nå en överenskommelse har Kunden rätt att säga upp Avtalet utan extra kostnad.
          </p>

          <h3>4.9 Överföring till tredje land</h3>
          <p>
            Personuppgifter lagras och behandlas inom EU/EES. Överföring till tredje land sker inte
            utan Kundens skriftliga godkännande och utan att lämpliga skyddsåtgärder enligt GDPR
            kapitel V vidtagits.
          </p>
        </section>

        <hr />

        <section>
          <h2>5. Immateriella rättigheter</h2>
          <ul>
            <li>Samtliga immateriella rättigheter till Systemet, inklusive källkod, design och dokumentation, tillhör Leverantören</li>
            <li>Kunden erhåller en begränsad, icke-exklusiv, icke-överlåtbar nyttjanderätt under avtalstiden</li>
            <li>Kunden äger all data som registreras i Systemet</li>
          </ul>
        </section>

        <hr />

        <section>
          <h2>6. Ansvarsbegränsning</h2>
          <ul>
            <li>Leverantörens ansvar regleras i Avtalet (punkt 9)</li>
            <li>Leverantören ansvarar inte för Kundens användning av Systemet i strid med gällande lagstiftning</li>
            <li>Leverantören ansvarar inte för innehållet i de uppgifter som Kunden registrerar i Systemet</li>
          </ul>
        </section>

        <hr />

        <section>
          <h2>7. Ändringar av villkoren</h2>
          <ul>
            <li>Leverantören har rätt att uppdatera dessa Villkor</li>
            <li>Väsentliga ändringar meddelas Kunden skriftligen minst 30 dagar i förväg</li>
            <li>Fortsatt användning av Systemet efter att uppdaterade Villkor trätt i kraft innebär godkännande av ändringarna</li>
            <li>Om Kunden inte godkänner ändringarna har Kunden rätt att säga upp Avtalet i enlighet med Avtalet punkt 12</li>
          </ul>
        </section>

        <hr />

        <section>
          <h2>8. Gällande lag</h2>
          <p>Dessa Villkor lyder under svensk lag. Tvister hanteras i enlighet med Avtalet punkt 13.</p>
        </section>

        <hr />

        <section>
          <h2>9. Kontaktuppgifter</h2>
          <p>Vid frågor om dessa Villkor eller om behandling av personuppgifter, kontakta:</p>
          <p>
            <strong>Tech Management Solutions Sweden AB</strong><br />
            E-post: antonnilspersson@gmail.com<br />
            Telefon: (+34) 620 139 456
          </p>
        </section>
      </div>
    </div>
  );
}

export default Tjanstevillkor;
